import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Button, Box, Text, TextInput } from "@mantine/core";
import { useTranslation } from "react-i18next";
import CustomInputComponent from "./CustomInputComponent";

export default function BasicForm({
  buttonText = "Save",
  buttonProps = {},
  fields = [],
  showButton = true,
  submitDisabled = false,
  onSubmit = () => {},
  children = null,
  loading = false,
}) {
  const { t } = useTranslation();
  let initialValues = {};
  let schemas = {};

  if (!fields.length) {
    return null;
  }

  fields.forEach((f) => {
    if (f.grouped) {
      f.fields.forEach((field) => {
        initialValues[field.name] = field.initialValue;
        schemas[field.name] = field.schema();
      });
    } else {
      initialValues[f.name] = f.initialValue;
      schemas[f.name] = f.schema();
    }
  });

  const schema = Yup.object().shape(schemas);
  const translatedButtonText = buttonText === "Save" ? t("save") : buttonText;

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values);
          // resetForm();
        }}
        enableReinitialize
      >
        {({ errors, touched }) => (
          <Form>
            <TextInput
              id="requiredReferralId"
              name="requiredReferralId"
              style={{
                display: "none",
              }}
            />
            {fields.map((f, i) => {
              return (
                <Box key={i} mb="xs">
                  <Field
                    addressLookup={f.addressLookup}
                    addressKeys={f.addressKeys}
                    checkbox={f.checkbox}
                    component={CustomInputComponent}
                    datepicker={f.datepicker}
                    disabled={f.disabled}
                    ignoreZip={f.ignoreZip}
                    label={f.label}
                    labelUrl={f.labelUrl}
                    mask={f.mask}
                    multiple={f.multiple}
                    name={f.name}
                    options={f.options}
                    radio={f.radio}
                    readOnly={f.readOnly}
                    required={f.required}
                    select={f.select}
                    search={f.search}
                    textarea={f.textarea}
                    timepicker={f.timepicker}
                    toggle={f.toggle}
                    zip={f.zip}
                  />
                </Box>
              );
            })}
            {Object.keys(touched).some((r) =>
              Object.keys(errors).includes(r)
            ) && (
              <Text c="red" mt="sm" fw={600} size="sm">
                {t("validation:form_error_text")}
              </Text>
            )}
            <div className="form-actions" style={{ marginTop: "1em" }}>
              {children}
              <Button
                type="submit"
                disabled={submitDisabled}
                loading={loading}
                {...buttonProps}
              >
                {translatedButtonText}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
